import { GlobalState } from '@leverege/ui-redux';
import I18N from '@leverege/i18n';
import { ItemDelegate, Relationship } from '@leverege/molten-core';
const {
  tf
} = I18N.ns('molten.imagine.blockers.LoadHierarchyBlocker');
export default {
  id: 'molten.blueprints.LoadHierarchyBlocker',
  name: tf('name'),
  sort: -1,
  matches: {
    path: '*'
  },
  execute: cxt => {
    const path = cxt?.relationship?.path;
    const match = cxt?.match;
    const p = [];
    if (path) {
      const arr = path.split('.');
      for (let n = 0; n < arr.length; n++) {
        const cPath = arr.slice(0, n + 1).join('.');
        const rel = Relationship.getByPath(cPath);
        if (rel == null || rel.apiName !== 'imagine') {
          break;
        }
        const relationship = rel.createItem(match);
        if (relationship == null) {
          break;
        }
        const action = new ItemDelegate({
          relationship,
          match
        });
        if (action.id != null && action.getItem(GlobalState.get(), true) == null) {
          // eslint-disable-next-line no-console
          p.push(GlobalState.dispatch(action.get()).then(d => d, console.error));
        }
      }
    }
    return Promise.all(p);
  }
};